import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import { FC } from 'react';
import { CameraIcon } from './Camera/Camera.styles';
import { useLanguage } from 'context/AppContext';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

type TSwitchCameraIcon = FC<{
  switchCamera: VoidFunction;
  sx?: SxProps<Theme>;
}>;

const SwitchCameraIcon: TSwitchCameraIcon = ({ switchCamera, sx }) => {
  const lang = useLanguage()[0].TrayImageCapture;

  return (
    <CameraIcon onClick={switchCamera} title={lang.switchCamera} sx={sx}>
      <CameraswitchIcon />
    </CameraIcon>
  );
};

export default SwitchCameraIcon;
